<template>
    <el-button type="primary" size="small" circle>
        <ComTooltip content="Muokkaa">
            <el-icon>
                <Edit></Edit>
            </el-icon>
        </ComTooltip>
    </el-button>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { Edit } from "@element-plus/icons-vue"
import ComTooltip from "../ComTooltip.vue"

export default defineComponent({
    components: {
        Edit,
        ComTooltip,
    },
})
</script>
